<div class="zk-w-full zk-flex zk-flex-wrap about-zenoffice">
	<div class="xl:zk-w-5/12 lg:zk-w-5/12 md:zk-w-7/12 sm:zk-w-full">
		<section class="description">
			<h1 class="title">{{ 'SIGN_UP.OFFICE.TITLE' | translate }}</h1>
			<h5
				class="subtitle"
				[innerHtml]="'SIGN_UP.OFFICE.CONTENT' | translate"
			></h5>
		</section>
	</div>
	<section
		class="zen-image xl:zk-w-7/12 lg:zk-w-7/12 md:zk-w-7/12 sm:zk-w-full"
	>
		<img
			alt="'SIGN_UP.OFFICE.IMG_ALT' | translate"
			class="md:align-center sm:align-center"
			id="zenoffice"
			src="/assets/images/about-zenoffice.png"
		/>
	</section>
</div>
